import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/home.vue';
import SitePage from '../views/site-page.vue';
import { pageMeta } from '@/data/sitePages';

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const siteUrl = 'https://gbapp.dev';

function metaFor(path, name) {
  const [title, description, keywords] = pageMeta[path] || [
    'GB WhatsApp Guide',
    'Read practical GB WhatsApp guides, tutorials, and feature explanations.',
    'GB WhatsApp',
  ];
  return {
    appname: 'GB WhatsApp',
    title,
    description,
    keywords,
    link: [{ rel: 'canonical', href: `${siteUrl}${path}` }],
    name,
  };
}

const innerPaths = [
  ['/download/', 'download'],
  ['/tutorials/', 'tutorials'],
  ['/tutorials/install/', 'tutorials-install'],
  ['/tutorials/update/', 'tutorials-update'],
  ['/tutorials/backup/', 'tutorials-backup'],
  ['/tutorials/verification/', 'tutorials-verification'],
  ['/tutorials/ban/', 'tutorials-ban'],
  ['/tutorials/transfer/', 'tutorials-transfer'],
  ['/features/', 'features'],
  ['/features/hide-online/', 'features-hide-online'],
  ['/features/anti-delete/', 'features-anti-delete'],
  ['/features/themes/', 'features-themes'],
  ['/features/dual-whatsapp/', 'features-dual-whatsapp'],
  ['/about-us/', 'about-us'],
  ['/contact-us/', 'contact-us'],
  ['/privacy-policy/', 'privacy-policy'],
  ['/terms-conditions/', 'terms-conditions'],
  ['/disclaimer/', 'disclaimer'],
];

export const constRoutesPc = [
  {
    path: '/',
    name: 'home',
    meta: {
      appname: 'GB WhatsApp',
      title: 'GB WhatsApp Download v18.80 APK (Anti-Ban 2026) for Android',
      description: 'Download GB WhatsApp v18.80 APK (Anti-Ban 2026) for Android. Explore the latest version with enhanced privacy options, customization features, chat tools, and updated guides.',
      keywords: 'GB WhatsApp APK Download, GB WhatsApp',
      link: [{ rel: 'canonical', href: `${siteUrl}/` }],
    },
    component: Home,
  },
  ...innerPaths.map(([path, name]) => ({
    path,
    name,
    meta: metaFor(path, name),
    component: SitePage,
  })),
  { path: '/download', redirect: '/download/' },
  { path: '/tutorials', redirect: '/tutorials/' },
  { path: '/features', redirect: '/features/' },
  { path: '/about-us', redirect: '/about-us/' },
  { path: '/contact-us', redirect: '/contact-us/' },
  { path: '/privacy-policy', redirect: '/privacy-policy/' },
  { path: '/terms-conditions', redirect: '/terms-conditions/' },
  { path: '/disclaimer', redirect: '/disclaimer/' },
  { path: '*', redirect: '/' },
];

export default function createRouter() {
  return new VueRouter({
    mode: 'history',
    routes: constRoutesPc,
    scrollBehavior(to, from, savedPosition) {
      return savedPosition || { x: 0, y: 0 };
    },
  });
}
